import { FunctionComponent, useEffect } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { Modal } from "@/components";

import { CreateCategory, CreateCategorySchema } from "../schema/objectionHandling";

interface AddCategoryModalProps {
	isOpen: boolean;
	onClose: () => void;
	onCreate: (data: CreateCategory) => void;
}

export const AddCategoryModal: FunctionComponent<AddCategoryModalProps> = ({
	isOpen,
	onClose,
	onCreate,
}) => {
	const {
		register,
		handleSubmit,
		reset,
		formState: { errors },
	} = useForm<CreateCategory>({
		defaultValues: { name: "" },
		resolver: zodResolver(CreateCategorySchema),
	});

	useEffect(() => {
		if (isOpen) {
			reset({ name: "" });
		}
	}, [isOpen, reset]);

	const onSubmit = (data: CreateCategory) => {
		onCreate(data);
		onClose();
	};

	return (
		<Modal
			handleClose={onClose}
			handleSave={handleSubmit(onSubmit)}
			isOpened={isOpen}
			submitButtonText="Create"
			title="Add Custom Category"
		>
			<div className="space-y-4">
				<div>
					<label className="block text-sm font-medium text-gray-700 mb-1">Category Name *</label>
					<input
						className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-light/30 focus:border-brand-light"
						placeholder="e.g. Budget-related objections"
						type="text"
						{...register("name")}
					/>
					{errors.name && <p className="mt-1 text-xs text-red-500">{errors.name.message}</p>}
				</div>
			</div>
		</Modal>
	);
};
